














import {Vue, Component, Prop} from 'vue-property-decorator';
import Datepicker from "vuejs-datepicker";
import datepickerMixin from "@/mixins/datepicker-mixin";

@Component({
    components: {Datepicker},
    mixins: [datepickerMixin],
})


export default class CustomDatePicker extends Vue {
    @Prop({required: false}) date!: number | Date | string;
    @Prop({required: false}) disabled!: boolean;

    private componentDate: number | Date | null | string = this.date;

    created() {
      console.log(this.date)
    }

    beforeUpdate() {
      this.componentDate = this.date
    }

    dateIsValid(date: number | Date | null): boolean {
      // prevents bug that sometime converts the year 20 -> 1920
      if (date) {
        return new Date(date).getFullYear() >= 2000;
      }
      return true;
    }

    dateIsComplete(date: number | Date | null): boolean {
      // datepicker validates with each keypress, need to check if the date entered is completely entered before we update props
      if (date) {
        const year = new Date(date).getFullYear();
        const yearString = year.toString();
        return yearString.length === 2 || yearString.length === 4;
      }
      return false;
    }

    openPicker(){
        // @ts-ignore
        this.$refs.programaticOpen.showCalendar();
    }

    onChange(value) {
      if (this.dateIsComplete(value)) {
        if (this.dateIsValid(value)) {
          this.$emit('update:date', value)
        } else {
          this.$emit('update:date', null)
        }
      }
    }
}
